// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as NLOrderLocationInfoVm from "./vm-mapper/NLOrderLocationInfoVm.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";

function getViewLabel(locations) {
  return {
          hd: {
            label: "Pickup Landmark",
            value: {
              TAG: /* Text */0,
              _0: locations.pickup_landmark
            }
          },
          tl: {
            hd: {
              label: "Contact",
              value: {
                TAG: /* Text */0,
                _0: locations.contact
              }
            },
            tl: {
              hd: {
                label: "From State",
                value: {
                  TAG: /* Text */0,
                  _0: locations.from_state
                }
              },
              tl: {
                hd: {
                  label: "To State",
                  value: {
                    TAG: /* Text */0,
                    _0: locations.to_state
                  }
                },
                tl: {
                  hd: {
                    label: "Drop Landmark",
                    value: {
                      TAG: /* Text */0,
                      _0: locations.drop_landmark
                    }
                  },
                  tl: /* [] */0
                }
              }
            }
          }
        };
}

function NLOrdersLocationInfo(Props) {
  var order = Props.order;
  var locations = NLOrderLocationInfoVm.getVm(order);
  return React.createElement(Accordion$Catalyst.make, {
              panels: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: "Order Location Information"
                    }, undefined, undefined, React.createElement(RecordsWrapper.make, {
                          children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(locations))
                        }), undefined),
                tl: /* [] */0
              },
              className: "c-nlo-accordion-cmp"
            });
}

var make = NLOrdersLocationInfo;

export {
  getViewLabel ,
  make ,
  
}
/* react Not a pure module */
